import App from './App.svelte';
import './app.css';

const app = new App({
	target: document.body,
});

export default app;